import apiClient from './apiClient';

export const getAllQuestions = async () => {
  const response = await apiClient.post('/question/getallquestions');
  return response.data.Data.Items || [];
};

export const getAllQuestionTypes = async () => {
  const response = await apiClient.post('/question/getallquestiontypes');
  return response.data.Data.Items || [];
};

export const addQuestion = async (dto) => {
  const response = await apiClient.post('/question/addquestion', dto);
  return response.data;
};

export const updateQuestion = async (dto) => {
  const response = await apiClient.post('/question/updatequestion', dto);
  return response.data;
};

export const deleteQuestion = async (id) => {
  const response = await apiClient.post('/question/deletequestion', null, {
    params: { Id: id },
  });
  return response.data;
};
